import React, { useState, useEffect, useRef } from "react";
import UploadService from "../../../../components/Admin/Operations/UserOrders/upload-files.service";

import Divider from "@mui/material/Divider";
import Dialog from "@mui/material/Dialog";

import "bootstrap/dist/css/bootstrap.min.css";
import InvoiceUploadModel from "./InvoiceUploadModel";

import axios from "../../../../api/axios";

import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";

import {
  Typography,
  Paper,
  Link,
  Grid,
  Radio,
  Select,
  Button,
  TextField,
  Checkbox,
  CssBaseline,
  RadioGroup,
  FormLabel,
  MenuItem,
  FormGroup,
  FormControl,
  FormControlLabel,
} from "@mui/material";

import "../Operations.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useLocation } from "react-router-dom";

export default function InvoiceUpload() {
  const [selectedFiles, setSelectedFiles] = useState(undefined);
  const [currentFile, setCurrentFile] = useState(undefined);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState("");
  const [fileInfos, setFileInfos] = useState([]);
  const [openDialogName, setOpenDialog] = useState(null);
  

  // const closeDialog = () => {
  //   setOpenDialog(null);
  //   paymentId.current = 0;
  // };

  // const openDialog = () => {
  //   alert("OpenDialog =======>    " + userId);
  //   /*alert('Selected Userid====' + userId);
  //   switch (openDialogName) {
  //     case 1:
  //       setOpenDialog(openDialogName);
  //       handleClose();
  //   }*/
  // };

  // useEffect(() => {
    /*UploadService.getFiles().then(response => {
      setFileInfos(response.data);
    });*/
  // }, []);

  // const selectFile = (event) => {
  //   setSelectedFiles(event.target.files);
  // };

  // const upload = () => {
  //   let currentFile = selectedFiles[0];

  //   setProgress(0);
  //   setCurrentFile(currentFile);

  //   UploadService.upload(currentFile, (event) => {
  //     setProgress(Math.round((100 * event.loaded) / event.total));
  //   })
  //     .then((response) => {
  //       setMessage(response.data.message);
  //       return UploadService.getFiles();
  //     })
  //     .then((files) => {
  //       setFileInfos(files.data);
  //     })
  //     .catch(() => {
  //       setProgress(0);
  //       setMessage("Could not upload the file!");
  //       setCurrentFile(undefined);
  //     });

  //   setSelectedFiles(undefined);
  // };

  return (
    <div style={{ padding: 25, paddingTop: 10, paddingBottom: 10 }}>
          <InvoiceUploadModel />
    </div>
  );
}
